export const hospitalConfig = {
  name: "All Is Well Multi-Speciality Hospital",
  tagline: "THE HOSPITAL THAT NEVER STOPS CARING™",
  brandTagline: "Sewa Dil Se",
  experienceName: "ALL IS WELL EXPERIENCE™",
  address: "Near Macro Vision Academy, Burhanpur, Madhya Pradesh 450331",
  phone: "+91 7697744444",
  phoneAlt: "+91 7089099888",
  phoneTel: "tel:+917697744444",
  emergency: "+91 7697744444",
  emergencyTel: "tel:+917697744444",
  // Official All Is Well WhatsApp — centralized config
  officialWhatsAppNumber: "917697744444",
  officialWhatsAppLink: "https://wa.me/917697744444",
  // Legacy alias kept for backward compatibility
  whatsapp: "https://wa.me/917697744444",
  email: "digitalmarketing@mvaburhanpur.com",
  hours: {
    weekdays: "Mon–Fri: 8AM – 8PM",
    weekends: "Sat–Sun: 9AM – 6PM",
  },
  maps: "https://maps.google.com/?q=All+Is+Well+Multi-Speciality+Hospital+Burhanpur+Madhya+Pradesh",
  social: {
    facebook: "https://facebook.com/alliswellhospital",
    instagram: "https://instagram.com/all.is.well.hospital",
    linkedin: "https://linkedin.com/company/alliswellhospital",
    youtube: "https://youtube.com/@alliswellhospital",
  },
  logo: "/assets/images/image-1786433963653.png",
  disclaimer:
    "This is a care navigation guide only. It does not constitute medical advice or diagnosis. Always consult a qualified medical professional for health concerns.",
};

/**
 * Build a context-aware WhatsApp URL using the official All Is Well number.
 * Only minimum journey context is included — no sensitive medical data.
 */
export function buildWhatsAppUrl(message: string): string {
  const base = hospitalConfig.officialWhatsAppLink;
  return `${base}?text=${encodeURIComponent(message)}`;
}

/** Pre-built context-aware message builders */
export const whatsAppMessages = {
  doctor: (doctorName: string, department: string, centre?: string) =>
    `Hello All Is Well, I want to enquire about a consultation with ${doctorName}, ${department}${centre ? `, at ${centre}` : ''}.`,

  diagnostics: (testName: string, centre?: string) =>
    `Hello All Is Well, I want to enquire about ${testName}${centre ? ` at ${centre}` : ''}.`,

  healthCheckup: (centre?: string) =>
    `Hello All Is Well, I want information about health check-ups available${centre ? ` at ${centre}` : ''}.`,

  pharmacy: (centre?: string) =>
    `Hello All Is Well, I need assistance regarding my prescription/medicines${centre ? ` at ${centre}` : ''}.`,

  centre: (centreName: string) =>
    `Hello All Is Well, I need assistance regarding ${centreName}.`,

  appointment: (doctorName: string, centre?: string) =>
    `Hello All Is Well, I need help with my appointment with ${doctorName}${centre ? ` at ${centre}` : ''}.`,

  general: () =>
    `Hello All Is Well, I would like some assistance.`,
};